/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(data) {
  var deferred = $.Deferred();
  $.soap({
    body: {
      GetActiveExternalUserJoinCodes: {
        $xmlns: 'http://dobs.pa.gov/cs/joincode/db/1.0',
        Email: data
      }
    },

    blueprintArrays: ['GetActiveExternalUserJoinCodesResponse.tuple'],
    blueprint: {
      joinCodes: [
        '$..tuple',
        {
          id: '$..ID',
          firstName: '$..FirstName',
          lastName: '$..LastName',
          email: '$..Email',
          joinCode: '$..JoinCode',
          issuedByUserId: '$..IssuedByUserID',
          isDeleted: '$..IsDeleted',
          isRegistered: '$..IsRegistered',
          sentDate: '$..SentDate',
          expiredDate: '$..ExpiredDate',
          registeredDate: '$..RegisteredDate',
          createdDate: '$..CreatedDate'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      _.each(response.joinCodes, function(joinCode) {
        if (joinCode.sentDate) {
          joinCode.sentDate = moment(joinCode.sentDate, moment.ISO_8601);
        }
        if (joinCode.expiredDate) {
          joinCode.expiredDate = moment(joinCode.expiredDate, moment.ISO_8601);
        }
        if (joinCode.registeredDate) {
          joinCode.registeredDate = moment(joinCode.registeredDate, moment.ISO_8601);
        }
        if (joinCode.createdDate) {
          joinCode.createdDate = moment(joinCode.createdDate, moment.ISO_8601);
        }
      });

      deferred.resolve(response.joinCodes);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
